import React, { useState } from "react";
import { IoShapesSharp } from "react-icons/io5";
import { RenderResponse } from "./RenderResponse";
import { RenderCitations } from "./RenderCitations";
import RenderFollowupQuestions from "./RenderFollowupQuestions";
export type ChatCardPropsType = {
    prompt?: string;
    response?: null | string | string[] | JSX.Element[] | JSON;
    citations?:
        // | null
        // | string
        // | string[]
        // | JSX.Element[]
        // | { text: string; link: string }
        // | { text: string; link: string }[]
        // | 
        Array<{ citation: string; link: string; title: string; author: string }>;
    isLoading?: boolean;
    followupQuestions?: string[];
    conversation_id?: string;
    from?: string;
    feed_back?: string;
    selectedIndex?: number;
    isIndexMatched?: boolean;
    checkedValue?: string;
    onCitationClick?: (path: string) => void;
    unableToAnswer?:boolean;
};

const UnableToAnswerChatCard: React.FC<ChatCardPropsType> = ({
    prompt,
    response,
    conversation_id,
    citations,
    followupQuestions,
    feed_back,
    from,
    selectedIndex,
    isIndexMatched,
    checkedValue,
    onCitationClick,
    unableToAnswer
}: ChatCardPropsType) => {
    // const checkedValue = "bad"
    const isLoading = response === null || response === "" || response === "";
    return (
        <div>
            {unableToAnswer  ? (
                <div className="rounded-lg">
                    <div className="flex items-center p-2 ">
                        <p className="text-lg font-semibold max-h-14 overflow-auto">{prompt}</p>
                    </div>
                    <div className="">
                        <div className="p-4 bg-amber-100 mb-6 rounded-lg relative min-w-[350px]">
                            <div className="">
                                <RenderResponse
                                    isLoading={isLoading}
                                    response={response}
                                    feed_back={feed_back}
                                    selectedIndex={selectedIndex}
                                    isIndexMatched={isIndexMatched}
                                />
                                <RenderCitations isLoading={isLoading} citations={citations} onCitationClick={onCitationClick} />
                            </div>
                        </div>
                        {citations && citations?.length > 0 && followupQuestions?.length ? (
                            <div className="w-2/2">
                                <RenderFollowupQuestions
                                    followupQuestions={followupQuestions}
                                    // onFollowupQuestionClicked={onFollowupQuestionClicked}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                        {/* </div> */}
                    </div>
                </div>
            ) : (
                <div className=" rounded-lg">
                    <div className="flex items-center p-2 ">
                        <div>
                            <p className="text-lg font-semibold max-h-14 overflow-auto">{prompt}</p>
                        </div>
                    </div>
                    <div className="">
                        <div className="p-4 bg-gray-300 mb-6 rounded-lg relative min-w-[350px]">
                            <div className="">
                                <RenderResponse
                                    isLoading={isLoading}
                                    response={response}
                                    feed_back={feed_back}
                                    selectedIndex={selectedIndex}
                                    isIndexMatched={isIndexMatched}
                                />
                                <RenderCitations isLoading={isLoading} citations={citations} onCitationClick={onCitationClick} />
                            </div>
                        </div>
                        {followupQuestions?.length ? (
                            <div className="w-2/2">
                                <RenderFollowupQuestions
                                    followupQuestions={followupQuestions}
                                    // onFollowupQuestionClicked={onFollowupQuestionClicked}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UnableToAnswerChatCard;
